window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

require('bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('dropzone');

window.Vue = require('vue');

window.Bugsnag = require('@bugsnag/js');

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
window.bootbox = require('bootbox');
window.parsley = require('parsleyjs');
window.moment = require('moment');
window.selectpicker = require('bootstrap-select');
window.select2 = require('select2');

window.Calendar = require('@fullcalendar/core').Calendar;
window.resourceTimelinePlugin = require('@fullcalendar/resource-timeline').default;
window.bootstrapPlugin = require('@fullcalendar/bootstrap').default;
window.interactionPlugin = require('@fullcalendar/interaction').default;

window.XLSX = require('xlsx');

// Custom Imports
window.approvalHandlers = require('../global/approvalHandlers').default;
